import React, { useState, useEffect } from "react";
import { Icon } from '@iconify/react/dist/iconify.js';
import axios from 'axios'; 
import { toast, ToastContainer } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css'; 
import { useNavigate } from "react-router-dom";

const ComplainFormPageDispatchUpdate = ({ complainId }) => {
  const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
  const storedUser = JSON.parse(localStorage.getItem('user'));
  const authUserId = storedUser._id;
  const navigate = useNavigate();

  const [formDataForest, setFormDataForest] = useState({ 
    forestZone: '',
    forestCircle: '',
    forestDivision: '',
   });
  
  const [options, setOptions] = useState({
    forestZones: [],
    forestCircles: [],
    forestDivisions: [],
  });

  const [formData, setFormData] = useState({
    dept_id: "",
    dept_name: "",
    district_id: "",
    complaint_district_name: "",
    complaint_number: "",
    complaint_nature_id: "",
    complaint_nature_name: "",
    complaint_nearby_place: "",
    complaint_detail: "",
    complainant_name: "",
    complainant_address: "",
    complainant_contact_no: "",
    complainant_email: "",
    complaint_time: "",
    complaint_additional_remarks: "",
    complainant_phone_secondry: "",
    other_nature: "",
    received_by: "",
    status: "Open",
    priority_level: "",
    cnic: "",
    complaint_source: "",
    complainant_city: "",
    complainant_tehsil: "",
    complainant_district: "",
    complaint_city: "",
    complaint_tehsil: "",
    complaint_district: "",
    complaint_address: ""
  });

  //const [ setComplaintNatures] = useState([]);
  //const [ setShowOtherInput] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch complaint data to update
  useEffect(() => {
    const fetchComplaintData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_BASE_URL}/backend/complaints/${complainId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data.status) {
          const complaintData = response.data.data;
          setFormData({
            dept_id: complaintData.dept_id?._id || "",
            dept_name: complaintData.dept_id?.name || "",
            complaint_number: complaintData.complaint_number || "",
            district_id: complaintData.complaint_district_id?._id || "",
            complaint_nature_id: complaintData.complaint_nature_id?._id || "",
            complaint_nature_name: complaintData.complaint_nature_id?.name || "",
            complaint_nearby_place: complaintData.near_by_place || "",
            complaint_detail: complaintData.complaint_detail || "",
            complainant_name: complaintData.complainant_name || "",
            complainant_address: complaintData.complainant_address || "",
            complainant_contact_no: complaintData.complainant_contact_no || "",
            complainant_email: complaintData.complainant_email || "",
            complaint_time: complaintData.time_of_call || "",
            complaint_additional_remarks: complaintData.remarks || "",
            complainant_phone_secondry: complaintData.complainant_contact_no_sec || "",
            other_nature: complaintData.other_nature || "",
            received_by: `${complaintData.received_by?.first_name || ''} ${complaintData.received_by?.last_name || ''}`.trim() || "",
            status: complaintData.status || "Open",
            priority_level: complaintData.priority_level || "",
            cnic: complaintData.complainant_cnic || "",
            complaint_source: complaintData.complaint_source || "",
            complainant_city: complaintData.complainant_city_id?.name || "",
            complainant_tehsil: complaintData.complainant_tehsil_id?.name || "",
            complainant_district: complaintData.complainant_district_id?.name || "",
            complaint_city: complaintData.complaint_city_id?.name || "",
            complaint_tehsil: complaintData.complaint_tehsil_id?.name || "",
            complaint_district: complaintData.complaint_district_id?.name || "",
            complaint_address: complaintData.complaint_address || "",
            lat: complaintData.lat || "",
            long: complaintData.long || "",

            assigned_to: `${complaintData.assigned_to?.first_name || ''} ${complaintData.assigned_to?.last_name || ''}`.trim() || "",
            dispatched_time: complaintData.dispatched_time || "",
            referred_by: complaintData.referred_by || "",
            dfo_remarks: complaintData.dfo_remarks || "",
            cancel_reason: complaintData.cancel_reason || ""

          });

          // if (complaintData.complaint_nature_id?.name?.toLowerCase() === "other") {
          //   //setShowOtherInput(true);
          // }
        }
      } catch (error) {
        toast.error("Failed to fetch complaint data.");
        console.error("Error fetching complaint data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchComplaintData();
  }, [API_BASE_URL, complainId, authUserId]);

  // // Fetch Complaint Natures
  // useEffect(() => {
  //   const fetchComplaintNatures = async () => {
  //     try {
  //       const token = localStorage.getItem("token");
  //       const response = await axios.get(`${API_BASE_URL}/backend/complaint-natures/get-all-complaint-natures`, {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });
  //       //setComplaintNatures(response.data.data);
  //     } catch (error) {
  //       toast.error("Failed to fetch complaint natures.");
  //       console.error("Error fetching complaint natures:", error);
  //     }
  //   };
  //   fetchComplaintNatures();
  // }, [API_BASE_URL]);

 
  const getPriorityClasses = (priority) => {
    switch (priority) {
        case "Low":
              return "bg-info-focus text-info-600"; // Green for Minor
        case "Medium":
            return "bg-success-focus text-success-600"; // Green for Minor
        case "High":
            return "bg-warning-focus text-warning-600"; // Yellow for Moderate
        case "Critical":
            return "bg-danger-focus text-danger-600"; // Red for Critical
        default:
            return "bg-secondary text-secondary-600"; // Default case
    }
   
};
 
  
  // Fetch all dropdown options on component mount
useEffect(() => {
  const fetchOptions = async () => {
    try {
      const endpoints = [
        'forestZone',
        'forestCircle',
        'forestDivision',
      ];
      
      const responses = await Promise.all(
        endpoints.map(endpoint => 
          axios.get(`${API_BASE_URL}/backend/generic/${endpoint}`)
        )
      );
      
      setOptions({
        forestZones: Array.isArray(responses[0].data.data) ? responses[0].data.data : [],
        forestCircles: Array.isArray(responses[1].data.data) ? responses[1].data.data : [],
        forestDivisions: Array.isArray(responses[2].data.data) ? responses[2].data.data : [],
      });
      
    } catch (error) {
      console.error('Error fetching dropdown options:', error);
    }
  };
  
  fetchOptions();
}, [API_BASE_URL]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataForest(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredFields = [
      'forestZone',
      'forestCircle',
      'forestDivision',
    ];

    const isFormValid = requiredFields.every((field) => formDataForest[field] !== "");

    if (!isFormValid) {
      toast.error("Please fill in all required details!");
      return;
    }

    // Prepare data for API - include all fields from formDataForest
    const apiData = {
      id: complainId,
      complaint_forest_zone_id: formDataForest.forestZone,
      complaint_forest_circle_id: formDataForest.forestCircle,
      complaint_forest_division_id: formDataForest.forestDivision,
    };

    // Remove the alert - it was just for debugging
    // alert(JSON.stringify(apiData));

    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${API_BASE_URL}/backend/complaints/dispatch`, 
        apiData, 
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        }
      );

      if (response.data.status) {
        navigate("/dispatch/list", { state: { showToast: true } });
      }
    } catch (error) {
      toast.error("Failed to update complaint. Please try again.");
      console.error("Error updating complaint:", error);
    }
  };

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="col-lg-12 col-md-12 col-sm-12">
      <ToastContainer />
      
      {/* Header Section */}
      <div className="text-center">
        {/* <h6 className="mb-20 text-2xl font-bold text-gray-800 flex items-center justify-center">
          <Icon icon="mdi:file-document-alert" className="text-3xl mx-3 my-1" />
          Dispatch Complaint
        </h6> */}
      </div>
      
      {/* Main Card */}
      <div className="card-body py-10 " >
        <div className="row justify-content-center" >
          <div className="col-lg-12">
            <div className="shadow-4 border radius-8">
              
              {/* Complaint Summary Section */}
              <div className="p-20 border-bottom fs-5"> {/* fs-5 for slightly larger text */}
                <div className="row justify-content-between g-3">

                  {/* Left Column */}
                  <div className="col-sm-6">
                    
                    <h4 className=" mb-20">Complaint # {formData.complaint_number} <span className={`px-3 py-1 rounded-pill fw-semibold text-xl ${getPriorityClasses(formData.priority_level)}`}>
                              {formData.priority_level || 'No Data Found'}
                            </span></h4>
                    
                    <div className="space-y-2">
                      {[
                        { label: 'Complaint Time', icon: 'mdi:clock-outline', value: formData.complaint_time },
                        { label: 'Department', icon: 'mdi:office-building', value: formData.dept_name },
                        { label: 'Source of Complaint', icon: 'mdi:source-branch', value: formData.complaint_source },
                       
                        {
                          label: 'Nature of Complaint',
                          icon: 'mdi:alert-circle',
                          value: (
                            <>
                              {formData.complaint_nature_name}
                              {formData.complaint_nature_name === 'Other' && formData.other_nature && (
                                <span className="ms-2 text-muted fst-italic">({formData.other_nature})</span>
                              )}
                            </>
                          )
                        },
                 
                       ].map(({ label, icon, value }, index) => (
                        <div key={index} className="d-flex justify-content-between">
                          <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                            <Icon icon={icon} /> {label}
                          </span>
                          <span className="col-1">:</span>
                          <span className="col-7 text-decoration-underline">{value}</span>
                        </div>
                      ))}
                      
                    </div>
                  </div>

                  {/* Right Column */}
                  <div className="col-sm-6 space-y-2">
                    {[
                      
                      { label: 'Nearby Place', icon: 'mdi:map-marker', value: formData.complaint_nearby_place },
                      { label: 'Complaint City', icon: 'mdi:city', value: formData.complaint_city },
                      { label: 'Complaint Tehsil', icon: 'mdi:map', value: formData.complaint_tehsil },
                      { label: 'Complaint District', icon: 'mdi:map-outline', value: formData.complaint_district },
                      { label: 'Complaint Address', icon: 'mdi:home-map-marker', value: formData.complaint_address },
                      { label: 'Received By', icon: 'mdi:account', value: formData.received_by },
                    
                    ].map(({ label, icon, value }, index) => (
                      <div key={index} className="d-flex justify-content-between">
                        <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                          <Icon icon={icon} /> {label}
                        </span>
                        <span className="col-1">:</span>
                        <span className="col-7 text-decoration-underline">{value}</span>
                      </div>
                    ))}
                  </div>

                </div>
              </div>
              <div className="py-28 px-20">
                <div className="row fs-5"> 
                  <div className="col-12 mt-3">
                        <h6 className="mb-3 text-success d-flex align-items-center gap-1 col-4 fw-bold"><Icon icon="mdi:clipboard-text" />Complaint Details</h6>
                        <p>{formData.complaint_detail || 'No Data Found'}</p>
                  </div>
                </div>
              </div>
               <hr/>
               <div className="py-28 px-20">
                <div className="row fs-5"> 
                  <div className="col-12 mt-3">
                        <h6 className="mb-3 text-success d-flex align-items-center gap-1 col-4 fw-bold"><Icon icon="mdi:text" />Additional Remarks</h6>
                        <p>{formData.complaint_additional_remarks || 'No Data Found'}</p>
                  </div>
                </div>
              </div>
              <hr/>
              {/* Complainant Information Section */}
              <div className="py-28 px-20">
                <div className="row fs-5"> {/* fs-5 for larger font */}

                  {/* Complainant Information (Left Column) */}
                  <div className="col-md-6">
                    <h6 className="text-md mb-3">Complainant Information:</h6>
                    <div className="space-y-2">
                      {[
                        { label: 'Name', icon: 'mdi:account', value: formData.complainant_name },
                        { label: 'Phone Number', icon: 'mdi:phone', value: formData.complainant_contact_no },
                        { label: 'Email', icon: 'mdi:email', value: formData.complainant_email },
                        { label: 'Phone Secondary', icon: 'mdi:phone', value: formData.complainant_phone_secondry },
                        { label: 'CNIC', icon: 'mdi:id-card', value: formData.cnic },
                      ].map(({ label, icon, value }, index) => (
                        <div key={index} className="d-flex mb-2">
                          <div className="col-4 fw-bold text-success d-flex align-items-center gap-1">
                            <Icon icon={icon} /> {label}
                          </div>
                          <div className="col-1 text-center">:</div>
                          <div className="col-7 text-decoration-underline">{value}</div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Complainant Address (Right Column) */}
                  <div className="col-md-6">
                    <h6 className="text-md mb-3">Complainant Address:</h6>
                    <div className="space-y-2">
                      {[
                        { label: 'Address', icon: 'mdi:home', value: formData.complainant_address },
                        { label: 'City', icon: 'mdi:city', value: formData.complainant_city },
                        { label: 'Tehsil', icon: 'mdi:map', value: formData.complainant_tehsil },
                        { label: 'District', icon: 'mdi:map', value: formData.complainant_district },
                      ].map(({ label, icon, value }, index) => (
                        <div key={index} className="d-flex mb-2">
                          <div className="col-4 fw-bold text-success d-flex align-items-center gap-1">
                            <Icon icon={icon} /> {label}
                          </div>
                          <div className="col-1 text-center">:</div>
                          <div className="col-7 text-decoration-underline">{value}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                
                {/* Dispatch Form Section */}
                <div className="mt-24">
                  <div className="scroll-sm">
                    <form onSubmit={handleSubmit}>
                      <div>
                        <div className="mb-4">
                          <div className="text-lg font-semibold">Dispatch Information</div>
                          <hr className="my-3" />
                          
                          <div className="row gy-3">
  
                            {/* Forest Zone */}
                            <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                              <label className="form-label d-flex align-items-center gap-2" htmlFor="forestZone">
                                <Icon icon="mdi:tree" className="text-lg" />
                                Forest Zone
                              </label>
                              <select
                                id="forestZone"
                                name="forestZone"
                                value={formDataForest.forestZone}
                                onChange={handleChange}
                                className="form-select"
                                required
                              >
                                <option value="">Select Forest Zone</option>
                                {options.forestZones.map(option => (
                                  <option key={option._id} value={option._id}>
                                    {option.name}
                                  </option>
                                ))}
                              </select>
                            </div>
  
                            {/* Forest Circle */}
                            <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                              <label className="form-label d-flex align-items-center gap-2" htmlFor="forestCircle">
                                <Icon icon="mdi:tree" className="text-lg" />
                                Forest Circle
                              </label>
                              <select
                                id="forestCircle"
                                name="forestCircle"
                                value={formDataForest.forestCircle}
                                onChange={handleChange}
                                className="form-select"
                                required
                              >
                                <option value="">Select Forest Circle</option>
                                {options.forestCircles.map(option => (
                                  <option key={option._id} value={option._id}>
                                    {option.name}
                                  </option>
                                ))}
                              </select>
                            </div>
  
                            {/* Forest Division */}
                            <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                              <label className="form-label d-flex align-items-center gap-2" htmlFor="forestDivision">
                                <Icon icon="mdi:tree" className="text-lg" />
                                Forest Division
                              </label>
                              <select
                                id="forestDivision"
                                name="forestDivision"
                                value={formDataForest.forestDivision}
                                onChange={handleChange}
                                className="form-select"
                                required
                              >
                                <option value="">Select Forest Division</option>
                                {options.forestDivisions.map(option => (
                                  <option key={option._id} value={option._id}>
                                    {option.name}
                                  </option>
                                ))}
                              </select>
                            </div>
  
                          </div>
                        </div>
                        
                        {/* Submit Button */}
                        <div className="d-flex justify-content-end">
                          <button
                            className="btn btn-success btn-sm px-6 py-12 radius-12 my-24 mx-10 col-lg-2 col-md-4 col-sm-12"
                            type="submit"
                          >
                            Dispatch Complaint
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComplainFormPageDispatchUpdate;